import React, { useContext, useEffect, useRef, useState } from "react";
import style from "../style/ForgetPassword.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LoginContext } from "../contexts/LoginContext";
import { useMutation } from "react-query";
import ReCAPTCHA from "react-google-recaptcha";
import apiClient from "../libraries/ApiClient";

const CssTextField = styled(TextField)({
  "& label.Mui-error": {
    color: "#EB4D3D",
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-error fieldset": {
      borderColor: "#EB4D3D",
    },
  },
});

const CssButton = styled(Button)({
  fontSize: 16,
  background: "#057AFF",
  "&:disabled": {
    border: "1px solid #818181",
    color: "#818181",
    background: "#E0E0E0",
  },
  "&:hover": {
    cursor: "pointer",
  },
});

function ForgetPassword() {
  const navigate = useNavigate();
  const [reCaptchaAppear, setReCaptchaAppear] = useState(false);
  const [reCaptchaIsDone, setReCaptchaIsDone] = useState(true);
  const [reCaptchaToken, setReCaptchaToken] = useState("");
  const [forgetFailCount, setForgetFailCount] = useState(0);
  const captchaRef = useRef(null);

  const {
    mailValue,
    mailValueIsValid,
    hasMailError,
    onChangeMailValue,
    onBlurMailValue,
    phoneValue,
    phoneValueIsValid,
    hasPhoneError,
    onChangePhoneValue,
    onBlurPhoneValue,
  } = useContext(LoginContext);

  const sendMailData = async ({ mailValue, phoneValue }) => {
    console.log(phoneValue);
    const data = {
      Data: {
        Identifier: mailValue,
        Phone: phoneValue,
        GoogleReCaptchaToken: reCaptchaToken,
      },
    };

    const res = await apiClient.postAes(
      "api/otp/send/forgotpwd/Security",
      data
    );
    return res;
  };

  const ReCaptchaHandler = () => {
    setReCaptchaIsDone(!reCaptchaIsDone);
  };

  const { data, mutate, isLoading } = useMutation(sendMailData);
  const { data: ResData } = data || {};
  const ResCode = +ResData?.Code;

  // console.log(ResData);

  useEffect(() => {
    setForgetFailCount(+localStorage.getItem("forgetFailCount"));
    let data = JSON.stringify(forgetFailCount);
    localStorage.setItem("forgetFailCount", data);
  }, []);

  useEffect(() => {
    if (forgetFailCount > 0) {
      let data = JSON.stringify(forgetFailCount);
      localStorage.setItem("forgetFailCount", data);
    }
  }, [forgetFailCount]);

  useEffect(() => {
    if (reCaptchaIsDone) {
      const reftoken = captchaRef.current?.getValue();
      setReCaptchaToken(reftoken);
    }
  }, [reCaptchaIsDone]);

  useEffect(() => {
    if (forgetFailCount >= 8) {
      setReCaptchaAppear(true);
      setReCaptchaIsDone(false);
    }
  }, [forgetFailCount]);

  useEffect(() => {
    if (ResCode === 0) {
      alert("已發送驗證碼");
      navigate("/VerificationCode");
      localStorage.removeItem("forgetFailCount");
    } else if (ResCode === 1) {
      alert(ResData?.Message);
      setForgetFailCount(+forgetFailCount + 1);
    }
  }, [ResCode]);

  return (
    <div className={style.forgetPassword_body}>
      <div className={style.forgetPassword_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.forgetPassword_form_body}>
        <div className={style.logo}>
          <img src="./end_logo.svg" alt="" style={{ width: "20%" }} />
        </div>
        <div className={style.forgetPassword_form}>
          <div className={style.forgetPassword_form_top}>
            <div className={style.forgetPassword_title}>忘記密碼?</div>
            <div className={style.forgetPassword_little_title}>
              請輸入您的帳號信箱，系統將發送驗證密碼給您！
            </div>
          </div>
          <div className={style.input_content}>
            <div className={style.input_mail}>
              <CssTextField
                label="請輸入帳號信箱"
                variant="outlined"
                onChange={onChangeMailValue}
                onBlur={onBlurMailValue}
                value={mailValue}
                error={hasMailError ? true : false}
                style={{ width: "100%" }}
              />
              <div
                style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}
              >
                {hasMailError && "格式錯誤，需符合信箱格式"}
              </div>
            </div>
            <div className={style.input_mail}>
              <CssTextField
                label="請輸入帳號手機"
                variant="outlined"
                onChange={onChangePhoneValue}
                onBlur={onBlurPhoneValue}
                value={phoneValue}
                error={hasPhoneError ? true : false}
                style={{ width: "100%" }}
              />
              <div
                style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}
              >
                {hasPhoneError && "格式錯誤，需符合手機格式"}
              </div>
            </div>
            {reCaptchaAppear && (
              <ReCAPTCHA
                sitekey={import.meta.env.VITE_RE_CAPTCHA_KEY}
                onChange={ReCaptchaHandler}
                ref={captchaRef}
                style={{ display: "flex", justifyContent: "center" }}
              ></ReCAPTCHA>
            )}
            <div className={style.btn}>
              <CssButton
                variant="contained"
                disabled={
                 ( !mailValueIsValid && !phoneValueIsValid) || isLoading
                }
                onClick={() => {
                  mutate({ mailValue, phoneValue });
                }}
              >
                下一步
              </CssButton>
              <Link
                to="/Login"
                style={{
                  textDecoration: "none",
                  color: "#057AFF",
                  textAlign: "center",
                  padding: "16px",
                  fontSize: "14px",
                }}
              >
                返回登入頁
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
